import { render, staticRenderFns } from "./supplier-evaluation-report.vue?vue&type=template&id=12d31f88&"
import script from "./supplier-evaluation-report.vue?vue&type=script&lang=js&"
export * from "./supplier-evaluation-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports